import { cn } from "@cliently/ui";
import Lottie from "lottie-react";

type LottieData = Record<string, unknown>;



export const LottieIllustration = ({
  animationData,
  className,
  size = 120,
  loop = true,
  autoplay = true,
}: {
  animationData: LottieData;
  className?: string;
  size?: number;
  loop?: boolean;
  autoplay?: boolean;
}) => {
  return (
    <div
      aria-hidden
      className={cn(
        "mx-auto flex select-none overflow-hidden pointer-events-none",
        className,
      )}
      style={{ width: size, height: size }}
    >
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        className="h-full w-full"
      />
    </div>
  );
}

